import PageHero from '../components/PageHero.jsx';

export default function Notes() {
  return (
    <div>
      <PageHero icon="./assets/eagle/page-icons/notes.png" title="Notes" />
    </div>
  );
}
